import { injectable } from 'inversify';
import type { AbstractCockpitApiErrorDataTransformer } from '@shared/common/error/data/transformer/abstract-cockpit-error.api-data-transformer';
import type { CockpitErrorResponseApiData } from '@shared/common/error/data/api-data/cockpit-error-response.api-data';
import { ConstraintValidationError } from '@shared/common/error/domain/error/constraint-validation.error';
import type { ViolationPageModel } from '@shared/common/validation/domain/model/validation-error-page.model';

@injectable()
export class ConstraintValidationApiErrorDataTransformer implements AbstractCockpitApiErrorDataTransformer {
  public map(data: CockpitErrorResponseApiData): ConstraintValidationError {
    const violations: ViolationPageModel[] = (data.violations ?? []).map((violation) => ({
      propertyPath: violation.propertyPath,
      message: violation.message ?? '',
    }));

    return new ConstraintValidationError(data.message ?? 'common.unexpected-error', violations, data.code);
  }
}
